import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const RfqDetailSkeleton: React.FC = () => (
  <div className="space-y-4">
    <div className="flex flex-wrap items-center gap-3">
      <Skeleton className="h-8 w-8" />
      <Skeleton className="h-5 w-12" />
      <Skeleton className="h-7 w-72" />
      <Skeleton className="h-5 w-20 rounded-full" />
      <Skeleton className="ml-auto h-8 w-40" />
    </div>
    <Skeleton className="h-56 w-full" />
    <Skeleton className="h-64 w-full" />
    <div className="grid gap-4 lg:grid-cols-2">
      <Skeleton className="h-40 w-full" />
      <Skeleton className="h-40 w-full" />
    </div>
  </div>
)
export default RfqDetailSkeleton
